import { render, staticRenderFns } from "./printViewer.vue?vue&type=template&id=bc2f533e&scoped=true&"
import script from "./printViewer.vue?vue&type=script&lang=js&"
export * from "./printViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2f533e",
  null
  
)

export default component.exports